import {firstValueFrom, Observable} from 'rxjs';
import {StorageMap} from '@ngx-pwa/local-storage';
import {inject, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private storage = inject(StorageMap);

  setItem = (key: string, value: any): Promise<void> => firstValueFrom(this.storage.set(key, value));

  removeItem = (key: string): Promise<void> => firstValueFrom(this.storage.delete(key));

  getItem = (key: string): Promise<any> => firstValueFrom(this.storage.get(key));

  clearItems = (): Promise<void> => firstValueFrom(this.storage.clear());

  /*** DATOSAPP ***/
  getApp = (): Promise<any> => this.getItem('DATOSAPP');

  getAppObs = (): Observable<any> => this.storage.get('DATOSAPP');

  setApp = (value: any): Promise<any> => this.setItem('DATOSAPP', value);

  /*** TOKEN ***/
  getToken = (): Promise<any> => this.getItem('TOKEN');

  setToken = (value: any): Promise<void> => this.setItem('TOKEN', value);

}